import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "arrow"]

  connect() {
    this.isOpen = false
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    if (!this.hasMenuTarget) return

    this.isOpen = true
    this.menuTarget.classList.remove('hidden')

    if (this.hasArrowTarget) {
      this.arrowTarget.classList.add('rotate-180')
    }
  }

  close() {
    if (!this.hasMenuTarget) return

    this.isOpen = false
    this.menuTarget.classList.add('hidden')

    if (this.hasArrowTarget) {
      this.arrowTarget.classList.remove('rotate-180')
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target) && this.isOpen) {
      this.close()
    }
  }
}
